/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromHelpers from './helpers.js'
import React from 'react'
import TableX from 'DesignSystem/TableX/react'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Settings/Content/TreatmentAutomations/AutomationsList/Content/Content",
  tableData
  
}) {
let onRowClick = fromHelpers.useOnRowClick({
  children,
  viewPath,
  tableData
  
})
  return (<React.Fragment
>
<TableX
  viewPath={`${viewPath}/TableX`}
 value={tableData}
 onRowClick={onRowClick}
 onGetBackgroundRowColor={fromHelpers.getBackgroundRowColor}
 heightRow={50}
/>
{children}
</React.Fragment>)
}